import { ReplaceWhitelistResponse, Web3Address } from 'multirpc-sdk';

import { AppDispatch } from 'store';
import { web3Api } from 'store/queries';

import { fetchProjectWhitelist } from '../fetchProjectWhitelist';
import { mapReplaceWhitelistResponse } from './mapReplaceWhitelistResponse';

export interface UpdateProjectWhitelistParams {
  dispatch: AppDispatch;
  replaceWhitelistResponse: ReplaceWhitelistResponse;
  teamAddress?: Web3Address;
  token: string;
}

export const updateProjectWhitelist = ({
  dispatch,
  replaceWhitelistResponse,
  teamAddress,
  token,
}: UpdateProjectWhitelistParams) => {
  dispatch(
    web3Api.util.upsertQueryData(
      fetchProjectWhitelist.name as never,
      { group: teamAddress, userEndpointToken: token } as never,
      mapReplaceWhitelistResponse(replaceWhitelistResponse) as never,
    ),
  );
};
